export default __webpack_public_path__ + "f7c1ba4814457cfc2c61bfe7f5919e3a.woff2";